<template>
  <div style="position: absolute; width: 100%; height: 100%; top: 0; background: #f0f3f7;overflow: hidden;">
    <!-- <div class="digSHowBox"
         v-if="carmerShow">
      <div class="cameraBox">
        <div style="font-family: Bold; font-size: 18px; text-align: center">人脸认证核验</div>
        <div style="margin-top: 8px">为保证考试严肃，需本人进行人脸认证核验后才能继续考试学习</div>
        <div style="margin-top: 28px"
             class="bkBox">
          <div class="bk">
            <img style="width: 171px; height: 171px"
                 src="../../assets/examImgs/bk.png"
                 alt="" />
          </div>
          <img v-if="showImg"
               :src="imgUrl"
               alt=""
               style="width: 170px; height: 170px" />
          <video v-if="!showImg"
                 style="border-radius: 12px"
                 id="videoCamera"
                 :width="videoWidth"
                 :height="videoHeight"
                 autoplay></video>
          <canvas id="canvasCamera"
                  style="display: none"
                  :width="videoWidth"
                  :height="videoHeight"></canvas>
        </div>

        <div @click="setImage()"
             class="camerBtn">立即认证核验</div>
      </div>
    </div> -->

    <div class="header">
      <div>{{ examInfo.paperName }}</div>
    </div>

    <div class="examBanner">
      <div class="examLeft">
        <div class="scollBox box1"
             >
          <div style="" class="box2">
            <div class="box3"></div>

            <div class="box4">答题卡</div>
          </div>

          <div class="box5"
               v-for="msg in examData"
               :key="msg.type">
            <!-- 单选题 -->
            <div v-if="msg.qType == '0501'">
              <div class="box6">单选题（共{{ danxuanList.length }}题，合计{{ danxuanList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div v-for="(item, index) in danxuanList"
                     :key="item.id"
                     :class="item.answerState == '02' ? 'color5 box7' : item.answerState == '01' ? 'color7 box7' : 'color6 box7'"
                     
                     @click="toSn(index)">
                  {{ index + 1 }}
                </div>
              </div>
            </div>
            <!-- 单选题end -->
            <!-- 多选题 -->
            <div class="box5"
                 v-if="msg.qType == '0502'">
              <div class="box6">多选题（共{{ duoxuanList.length }}题，合计{{ duoxuanList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div v-for="(item, index) in duoxuanList"
                     :key="item.id"
                     :class="item.answerState == '02' ? 'color5 box7' : item.answerState == '01' ? 'color7 box7' : 'color6 box7'"
                     
                     @click="toSn(danxuanList.length + index)">
                  {{ danxuanList.length + 1 + index }}
                </div>
              </div>
            </div>
            <!-- 多选题end -->
            <!-- 判断题 -->
            <div class="box5"
                 v-if="msg.qType == '0503'">
              <div class="box6">判断题（共{{ panduanList.length }}题，合计{{ panduanList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div v-for="(item, index) in panduanList"
                     :key="item.id"
                     :class="item.answerState == '02' ? 'color5 box7' : item.answerState == '01' ? 'color7 box7' : 'color6 box7'"
                     
                     @click="toSn(danxuanList.length + duoxuanList.length + index)">
                  {{ danxuanList.length + duoxuanList.length + 1 + index }}
                </div>
              </div>
            </div>
            <!-- 判断题end -->
            <!-- 简答题 -->
            <div class="box5"
                 v-if="msg.qType == '0504'">
              <div class="box6">简答题（共{{ jiandaList.length }}题，合计{{ jiandaList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div v-for="(item, index) in jiandaList"
                     :key="item.id"
                     :class="item.answerState == '02' ? 'color5 box7' : item.answerState == '01' ? 'color7 box7' : item.answerState == '05' ? 'color11 box7' : 'color6 box7'"
                     
                     @click="toSn(danxuanList.length + duoxuanList.length + panduanList.length + index)">
                  {{ danxuanList.length + duoxuanList.length + panduanList.length + 1 + index }}
                </div>
              </div>
            </div>
            <!-- 简答题end -->

            <!-- 阅读理解题 -->
            <div class="box5"
                 v-if="msg.qType == '0506'">
              <div class="box6">阅读理解题（共{{ shicaoList.length }}题，合计{{ shicaoList[0].totalGrade }}分）</div>

              <div class="danBox">
                <div v-for="(item, index) in shicaoList"
                     :key="item.id"
                     :class="item.answerState == '02' ? 'color5 box7' : item.answerState == '01' ? 'color7 box7' : item.answerState == '05' ? 'color11 box7' : 'color6 box7'"
                     
                     @click="toSn(danxuanList.length + duoxuanList.length + panduanList.length + jiandaList.length + index)">
                  {{ danxuanList.length + duoxuanList.length + panduanList.length + jiandaList.length + 1 + index }}
                </div>
              </div>
            </div>
            <!-- 阅读理解题end -->
          </div>
        </div>
        <div  class="optionTips" style="display: flex;justify-content: center; align-items: center;">

          <div>
            <div style="display: flex;">
                <div class="yuan box8" style="background: #7e3b8e;"></div>
                <div class="box9">待批改</div>

                <div class="yuan box8"
                style="background: #fe5f5e; "></div>
            <div class="box9">错误</div>
            </div>
          <div style="display: flex;">
            <div class="yuan box8"
               style="background: #f1f3f7;"></div>
            <div class="box9">未答题</div>
           

              <div class="yuan box8"
                style="background: #5ad068;"></div>
            <div class="box9">正确</div>
          </div>
          </div>

      </div>
      </div>
      <!-- 题目选项模块 -->
      <div class="examCenter">
        <swiper id="swiper"
                ref="mySwiper"
                class="swiper swiper-no-swiping">
          <swiper-slide v-for="(item, index) in danxuanList"
                        :key="item.id">
            <!-- 单选题 -->
            <div style="display: flex">
              <div class="timu">
                <div class="titleTips">单选题</div>
                <div>{{ index + 1 }}: {{ item.content }}</div>
                <div class="box10"
                     v-for="(img, idx) in item.imgs"
                     :key="idx">
                  <img style="width: 100%"
                       :src="img"
                       alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box11"
                     
                     :key="num">
                  <div v-for="(data, idx) in item.optionList"
                       :key="data.id"
                       :class="
                      data.selected && item.answerState == '02'
                        ? 'seletXuan xuan'
                        : data.selected && item.answerState == '01'
                        ? 'noseletXuan xuan'
                        : 'xuan'
                    ">
                    <div>
                      <img v-if="!data.selected"
                          class="box12"
                           src="../../assets/examImgs/nos@2x.png"
                           alt="" />
                      <img v-else
                          class="box12"
                           src="../../assets/examImgs/se@2x.png"
                           alt="" />
                    </div>
                    <div class="box8">
                      <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span>&emsp;{{ data.opContent }}
                    </div>

                    <div class="box13"
                         v-for="(img, idx) in data.imgs"
                         :key="idx">
                      <img style="width: 100%"
                           :src="img"
                           alt="" />
                    </div>
                  </div>
                </div>
                <div class="successBox">
                  正确答案：{{
                    item.asw == '0'
                      ? 'A'
                      : item.asw == '1'
                      ? 'B'
                      : item.asw == '2'
                      ? 'C'
                      : item.asw == '3'
                      ? 'D'
                      : item.asw == '4'
                      ? 'E'
                      : item.asw == '5'
                      ? 'F'
                      : item.asw == '6'
                      ? 'G'
                      : 'H'
                  }}
                </div>
                <div class="switchBox">
                  <div class="btn"
                       style="color: #4275f5"
                       @click="upTi(index)">上一题</div>
                  <div @click="dowTi(item, index)"
                       class="btn box14"
                      >
                    下一题
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide v-for="(item, index) in duoxuanList"
                        :key="item.id">
            <!-- 多选题 -->
            <div style="display: flex">
              <div class="timu">
                <div class="titleTips">多选题</div>
                <div>{{ danxuanList.length + 1 + index }}: {{ item.content }}</div>
                <div class="box10"
                     v-for="(img, idx) in item.imgs"
                     :key="idx">
                  <img style="width: 100%"
                       :src="img"
                       alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box11"
                     >
                  <div v-for="(data, idx) in item.optionList"
                       :key="data.id">
                    <div :key="num"
                         :class="
                        data.selected && item.answerState == '02'
                          ? 'seletXuan xuan'
                          : data.selected && item.answerState == '01'
                          ? 'noseletXuan xuan'
                          : 'xuan'
                      ">
                      <div>
                        <img v-if="!data.selected"
                            class="box12"
                             src="../../assets/examImgs/nos@2x.png"
                             alt="" />
                        <img v-else
                            class="box12"
                             src="../../assets/examImgs/se@2x.png"
                             alt="" />
                      </div>
                      <div class="box8">
                        <span style="font-family: Bold">{{
                          idx == 0
                            ? 'A'
                            : idx == 1
                            ? 'B'
                            : idx == 2
                            ? 'C'
                            : idx == 3
                            ? 'D'
                            : idx == 4
                            ? 'E'
                            : idx == 5
                            ? 'F'
                            : idx == 6
                            ? 'G'
                            : idx == 7
                            ? 'H'
                            : 'I'
                        }}</span>&emsp;{{ data.opContent }}
                      </div>
                      <div class="box10"
                           v-for="(img, idx) in data.imgs"
                           :key="idx">
                        <img style="width: 100%"
                             :src="img"
                             alt="" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="successBox">
                  正确答案：<span v-for="(cc, cidx) in item.asw"
                        :key="cidx">
                    <span v-if="cc !== ','">
                      {{
                        cc == '0'
                          ? 'A'
                          : cc == '1'
                          ? 'B'
                          : cc == '2'
                          ? 'C'
                          : cc == '3'
                          ? 'D'
                          : cc == '4'
                          ? 'E'
                          : cc == '5'
                          ? 'F'
                          : cc == '6'
                          ? 'G'
                          : 'H'
                      }}
                    </span>
                  </span>
                </div>

                <div class="switchBox">
                  <div class="btn"
                       style="color: #4275f5"
                       @click="upTi(index)">上一题</div>
                  <div @click="dowTi(item, index)"
                       class="btn box14"
                      >
                    下一题
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide v-for="(item, index) in panduanList"
                        :key="item.id">
            <!-- 判断 -->
            <div style="display: flex">
              <div class="timu">
                <div class="titleTips">判断题</div>
                <div>{{ danxuanList.length + duoxuanList.length + 1 + index }}: {{ item.content }}</div>
                <div class="box10"
                     v-for="(img, idx) in item.imgs"
                     :key="idx">
                  <img style="width: 100%"
                       :src="img"
                       alt="" />
                </div>
              </div>
              <div class="xuanx">
                <div class="scollBox box11"
                     
                     :key="num">
                  <div v-for="(data, idx) in item.optionList"
                       :key="idx"
                       :class="
                      data.selected && item.answerState == '02'
                        ? 'seletXuan xuan'
                        : data.selected && item.answerState == '01'
                        ? 'noseletXuan xuan'
                        : 'xuan'
                    ">
                    <div>
                      <img v-if="!data.selected"
                          class="box12"
                           src="../../assets/examImgs/nos@2x.png"
                           alt="" />
                      <img v-else
                          class="box12"
                           src="../../assets/examImgs/se@2x.png"
                           alt="" />
                    </div>
                    <div class="box8">
                      <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span>&emsp;{{ data.opContent }}
                    </div>
                  </div>
                </div>

                <div class="successBox">正确答案：{{ item.answer == '01' ? '正确' : '错误' }}</div>

                <div class="switchBox">
                  <div class="btn"
                       style="color: #4275f5"
                       @click="upTi(index)">上一题</div>
                  <div @click="dowTi(item, index)"
                       class="btn box14"
                      >
                    下一题
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>

          <swiper-slide v-for="(item, index) in jiandaList"
                        :key="item.id">
            <!-- 简答 -->
            <div style="display: flex">
              <div class="timu">
                <div class="titleTips">简答题</div>
                <div>{{ danxuanList.length + duoxuanList.length + panduanList.length + 1 + index }}: {{ item.content }}</div>
                <div class="box10"
                     v-for="(img, idx) in item.imgs"
                     :key="idx">
                  <img style="width: 100%"
                       :src="img"
                       alt="" />
                </div>
              </div>
              <div class="xuanx box15"
                   >
                <div class="scollBox box11"
                     
                     :key="num">
                  <el-input class="box16"
                            type="textarea"
                            :autosize="{ minRows: 20, maxRows: 30 }"
                            placeholder="请考生作答"
                            v-model="item.z"
                            disabled>
                  </el-input>
                </div>

                <div class="successBox">参考答案：{{ item.answer }}</div>

                <div class="switchBox">
                  <div class="btn"
                       style="color: #4275f5"
                       @click="upTi(index)">上一题</div>
                  <div @click="dowTi(item, index)"
                       class="btn box14"
                      >
                    下一题
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>

          <swiper-slide v-for="(item, index) in shicaoList"
                        :key="item.id">
            <!-- 阅读理解 -->
            <div style="display: flex">
              <div class="timu">
                <div class="titleTips">阅读理解题</div>
                <div>
                  {{ danxuanList.length + duoxuanList.length + jiandaList.length + panduanList.length + 1 + index }}: {{ item.content }}
                </div>
                <div class="box10"
                     v-for="(img, idx) in item.imgs"
                     :key="idx">
                  <img style="width: 100%"
                       :src="img"
                       alt="" />
                </div>

                <!-- 子单选题目 -->
                <div v-if="item.read_1.length !== 0">
                  <div>单选题</div>
                  <div class="timu box17"
                       
                       v-for="(msg, idx) in item.read_1"
                       :key="msg.pqId">
                    <div class="box9">&emsp;({{ idx + 1 }})&emsp;{{ msg.question.content }}</div>
                    <div class="box10"
                         v-for="(img, idx) in msg.imgs"
                         :key="idx">
                      <img style="width: 100%"
                           :src="img"
                           alt="" />
                    </div>
                  </div>
                </div>
                <!-- 子单选题目end -->

                <!-- 子多选题目 -->
                <div v-if="item.read_2.length !== 0">
                  <div>多选题</div>
                  <div class="timu box17"
                       
                       v-for="(msg, idx) in item.read_2"
                       :key="msg.pqId">
                    <div class="box9">&emsp;({{ idx + 1 }})&emsp;{{ msg.question.content }}</div>
                    <div class="box10"
                         v-for="(img, idx) in msg.imgs"
                         :key="idx">
                      <img style="width: 100%"
                           :src="img"
                           alt="" />
                    </div>
                  </div>
                </div>
                <!-- 子多选题目end -->
                <!-- 子判断题目 -->
                <div v-if="item.read_3.length !== 0">
                  <div>判断题</div>
                  <div class="timu box17"
                       
                       v-for="(msg, idx) in item.read_3"
                       :key="msg.pqId">
                    <div class="box9">&emsp;({{ idx + 1 }})&emsp;{{ msg.question.content }}</div>
                    <div class="box10"
                         v-for="(img, idx) in msg.imgs"
                         :key="idx">
                      <img style="width: 100%"
                           :src="img"
                           alt="" />
                    </div>
                  </div>
                </div>
                <!-- 子判断题目end -->

                <!-- 子简答题 -->
                <div v-if="item.read_4.length !== 0">
                  <div>简答题</div>
                  <div class="timu box17"
                       
                       v-for="(msg, idx) in item.read_4"
                       :key="msg.pqId">
                    <div class="box9">&emsp;({{ idx + 1 }})&emsp;{{ msg.question.content }}</div>
                    <div class="box10"
                         v-for="(img, idx) in msg.imgs"
                         :key="idx">
                      <img style="width: 100%"
                           :src="img"
                           alt="" />
                    </div>
                  </div>
                </div>
                <!-- 子简答题end -->
              </div>
              <div class="xuanx box15"
                   >
                <div class="scollBox box18"
                     >
                  <!-- 子单选题选项 -->
                  <div v-if="item.read_1.length">
                    <div class="box19">单选题选项</div>
                    <div v-for="(dzt, cindex) in item.read_1"
                         :key="dzt.pqId">
                      <div class="box19">({{ cindex + 1 }})</div>
                      <div v-for="(data, idx) in dzt.question.optionList"
                           :key="data.id"
                           :class="
                          data.selected && dzt.question.answerState == '02'
                            ? 'seletXuan xuan'
                            : data.selected && dzt.question.answerState == '01'
                            ? 'noseletXuan xuan'
                            : 'xuan'
                        ">
                        <div>
                          <img v-if="!data.selected"
                              class="box12"
                               src="../../assets/examImgs/nos@2x.png"
                               alt="" />
                          <img v-else
                              class="box12"
                               src="../../assets/examImgs/se@2x.png"
                               alt="" />
                        </div>
                        <div class="box8">
                          <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span>&emsp;{{ data.opContent }}
                        </div>

                        <div class="box13"
                             v-for="(img, idx) in data.imgs"
                             :key="idx">
                          <img style="width: 100%"
                               :src="img"
                               alt="" />
                        </div>
                      </div>

                      <div class="successBox">
                        正确答案：{{
                          dzt.question.asw == '0'
                            ? 'A'
                            : dzt.question.asw == '1'
                            ? 'B'
                            : dzt.question.asw == '2'
                            ? 'C'
                            : dzt.question.asw == '3'
                            ? 'D'
                            : dzt.question.asw == '4'
                            ? 'E'
                            : dzt.question.asw == '5'
                            ? 'F'
                            : dzt.question.asw == '6'
                            ? 'G'
                            : 'H'
                        }}
                      </div>
                    </div>
                  </div>
                  <!-- 子单选题选项end -->

                  <!-- 子多选题选项 -->
                  <div v-if="item.read_2.length">
                    <div class="box19">多题选项</div>

                    <div v-for="(dzt, cindex) in item.read_2"
                         :key="dzt.pqId">
                      <div class="box19">({{ cindex + 1 }})</div>
                      <div v-for="(data, idx) in dzt.question.optionList"
                           :key="data.id"
                           :class="
                          data.selected && dzt.question.answerState == '02'
                            ? 'seletXuan xuan'
                            : data.selected && dzt.question.answerState == '01'
                            ? 'noseletXuan xuan'
                            : 'xuan'
                        ">
                        <div>
                          <img v-if="!data.selected"
                              class="box12"
                               src="../../assets/examImgs/nos@2x.png"
                               alt="" />
                          <img v-else
                              class="box12"
                               src="../../assets/examImgs/se@2x.png"
                               alt="" />
                        </div>
                        <div class="box8">
                          <span style="font-family: Bold">{{
                            idx == 0
                              ? 'A'
                              : idx == 1
                              ? 'B'
                              : idx == 2
                              ? 'C'
                              : idx == 3
                              ? 'D'
                              : idx == 4
                              ? 'E'
                              : idx == 5
                              ? 'F'
                              : idx == 6
                              ? 'G'
                              : idx == 7
                              ? 'H'
                              : 'I'
                          }}</span>&emsp;{{ data.opContent }}
                        </div>

                        <div class="box13"
                             v-for="(img, idx) in data.imgs"
                             :key="idx">
                          <img style="width: 100%"
                               :src="img"
                               alt="" />
                        </div>
                      </div>
                      <div class="successBox">
                        正确答案：<span v-for="(cc, cidx) in dzt.question.asw"
                              :key="cidx">
                          <span v-if="cc !== ','">
                            {{
                              cc == '0'
                                ? 'A'
                                : cc == '1'
                                ? 'B'
                                : cc == '2'
                                ? 'C'
                                : cc == '3'
                                ? 'D'
                                : cc == '4'
                                ? 'E'
                                : cc == '5'
                                ? 'F'
                                : cc == '6'
                                ? 'G'
                                : 'H'
                            }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- 子多选题选项end -->

                  <!-- 子判断题选项 -->
                  <div v-if="item.read_3.length">
                    <div class="box19">判断题选项</div>

                    <div v-for="(dzt, cindex) in item.read_3"
                         :key="dzt.pqId">
                      <div class="box19">({{ cindex + 1 }})</div>
                      <div v-for="(data, idx) in dzt.optionList"
                           :key="data.id"
                           :class="
                          data.selected && dzt.question.answerState == '02'
                            ? 'seletXuan xuan'
                            : data.selected && dzt.question.answerState == '01'
                            ? 'noseletXuan xuan'
                            : 'xuan'
                        ">
                        <div>
                          <img v-if="!data.selected"
                              class="box12"
                               src="../../assets/examImgs/nos@2x.png"
                               alt="" />
                          <img v-else
                              class="box12"
                               src="../../assets/examImgs/se@2x.png"
                               alt="" />
                        </div>
                        <div class="box8">
                          <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span>&emsp;{{ data.opContent }}
                        </div>
                        <div class="box13"
                             v-for="(img, idx) in data.imgs"
                             :key="idx">
                          <img style="width: 100%"
                               :src="img"
                               alt="" />
                        </div>
                      </div>
                      <div class="successBox">正确答案：{{ dzt.question.answers == '01' ? '正确' : '错误' }}</div>
                    </div>
                  </div>
                  <!-- 子判断题选项end -->

                  <!-- 子简答题选项 -->
                  <div v-if="item.read_4.length">
                    <div class="box19">简答题选项</div>

                    <div v-for="(dzt, cindex) in item.read_4"
                         :key="dzt.pqId">
                      <div class="box19">({{ cindex + 1 }})</div>
                      <el-input type="textarea"
                                :autosize="{ minRows: 20, maxRows: 30 }"
                                placeholder="请考生作答"
                                disabled
                                v-model="dzt.z">
                      </el-input>
                      <div class="successBox box20"
                           >参考答案：{{ dzt.question.answers }}</div>
                    </div>
                  </div>
                  <!-- 子简答题选项end -->
                </div>

                <div class="switchBox">
                  <div class="btn"
                       style="color: #4275f5"
                       @click="upTi(index)">上一题</div>
                  <div @click="dowTi(item, index)"
                       class="btn box14"
                      >
                    下一题
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <!-- 题目选项模块end -->
      <div class="examRight">
        <div class="box21">
          <div class="box22">
            <div class="box3"></div>

            <div class="box4">考试须知</div>
          </div>

          <div class="box23">
            <div class="fs scollBox">
              {{ examInfo.quizDescription }}
            </div>
          </div>
        </div>
        <div class="box24">
          <div class="box22">
            <div class="box3"></div>

            <div class="box4">题目回顾</div>
          </div>

          <div class="box25">
            <div class="box26">
              <div class="yuan box8"
                   style="background: #f1f3f7; "></div>
              <div class="box9">未答：{{ this.examInfo.not }}题</div>
            </div>
            <div class="box26">
              <div class="yuan box8"
                   style="background: #fe5f5e;"></div>
              <div class="box9">错误：{{ this.examInfo.wrong }}题</div>
            </div>
            <div class="box26">
              <div class="yuan box8"
                   style="background: #5ad068;"></div>
              <div class="box9">正确：{{ this.examInfo.correct }}题</div>
            </div>
          </div>

          <div class="box27"
               @click="overH">
            <div class="submit">
              <div style="display: flex">
                <div>
                  <img class="box28"
                       src="../../assets/examImgs/submit@2x.png"
                       alt="" />
                </div>
                <div class="box9">结束回顾</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// Import Swiper Vue.js components
import { toPreview, handInNew, doSign, handIn } from '../../api/questions';
// Import Swiper styles
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      examData: [], //题目数据
      swiperIndex: 0, //当前页面的题目索引
      num: 0, //key值重置
      danxuanList: [], //单选题的数组
      duoxuanList: [], //多选题
      panduanList: [], //判断题
      jiandaList: [], //简答题
      shicaoList: [], //阅读理解,阅读理解
      videoWidth: 170,
      videoHeight: 170,
      imgSrc: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      //相机截图工具
      face_back_canvas: null,
      //截图内容
      face_back_context: null,
      //照片的base64码值
      face_back_base64Photo: '',
      showImg: false, //截图的图片
      carmerShow: true, //人脸识别组件
      examInfo: {}, //试卷数据
      timeimit: 0, //倒计时
      time: '', //倒计时
      interval: null, //定时器
      isSign: '01', //签到状态
      percentageNum: 0, //已做
      totleNum: 0 //总数
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //结束回顾
    overH() {
      this.$router.push({ path: '/examPage'});
    },
    //处理考试进度百分比
    percentage() {
      this.totleNum =
        this.danxuanList.length + this.duoxuanList.length + +this.panduanList.length + this.jiandaList.length + this.shicaoList.length;
    },
    //五分钟提交一下试卷
    handIn() {
      let data = {
        uqId: this.examInfo.uqId,
        uqdId: this.examInfo.uqdId,
        type: '01'
      };
      this.danxuanList.forEach(v => {
        v.optionList.forEach(x => {
          if (x.selected) {
            data[v.pqId] = x.id;
          }
        });
      });
      this.duoxuanList.forEach(v => {
        let arr = [];
        v.optionList.forEach(x => {
          if (x.selected) {
            console.log(x);
            arr.push(x.id);
            console.log(arr);
            data[v.pqId] = arr.toString();
          }
        });
      });
      this.panduanList.forEach(v => {
        v.optionList.forEach(x => {
          if (x.selected) {
            data[v.pqId] = x.opContent == '是' ? '01' : '00';
          }
        });
      });

      this.jiandaList.forEach(v => {
        if (v.z && v.z !== '') {
          data[v.pqId] = v.z;
        }
      });

      this.shicaoList.forEach(c => {
        if (c.read_1.length !== 0) {
          c.read_1.forEach(v => {
            v.optionList.forEach(x => {
              if (x.selected) {
                data[v.pqId] = x.id;
              }
            });
          });
        }

        if (c.read_2.length !== 0) {
          c.read_2.forEach(v => {
            let arr = [];
            v.optionList.forEach(x => {
              if (x.selected) {
                console.log(x);
                arr.push(x.id);
                console.log(arr);
                data[v.pqId] = arr.toString();
              }
            });
          });
        }

        if (c.read_3.length !== 0) {
          c.read_3.forEach(v => {
            v.optionList.forEach(x => {
              if (x.selected) {
                data[v.pqId] = x.opContent == '是' ? '01' : '00';
              }
            });
          });
        }

        if (c.read_4.length !== 0) {
          c.read_4.forEach(v => {
            if (v.z && v.z !== '') {
              data[v.pqId] = v.z;
            }
          });
        }
      });
      handIn(data).then(res => {
        console.log(res);
      });
    },
    //签到
    onQd() {
      doSign({ uqId: this.examInfo.uqId }).then(res => {
        console.log(res);
        if (res.data.code == '200') {
          this.isSign = '02';
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          });
        }
      });
    },
    //答题卡点击事件
    toSn(idx) {
      console.log(idx);
      if (this.isSign == '01') {
        this.$message({
          message: '请先签到之后再答题！',
          type: 'warning'
        });
        return false;
      }
      this.$refs.mySwiper.swiperInstance.slideTo(idx);
      this.swiperIndex = this.$refs.mySwiper.swiperInstance.activeIndex;
    },
    //上一题
    upTi(index) {
      this.$refs.mySwiper.swiperInstance.slidePrev();
      this.swiperIndex = this.$refs.mySwiper.swiperInstance.activeIndex;
      window.scrollTo(0, 0);
    },
    //下一题
    dowTi(item, index) {
      if (item.z) {
        this.percentageNum = this.percentageNum + 1;
      }
      if (this.isSign == '01') {
        this.$message({
          message: '请先签到之后再答题！',
          type: 'warning'
        });
        return false;
      }
      this.$refs.mySwiper.swiperInstance.slideNext();
      this.swiperIndex = this.$refs.mySwiper.swiperInstance.activeIndex;
      window.scrollTo(0, 0);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //题目接口数据
    toPreview({ uqdId: this.$route.query.id }).then(res => {
      console.log(res);
      this.examData = res.data.data.list;
      this.examInfo = res.data.data;
      this.isSign = res.data.data.isSign;
      this.examData.forEach(item => {
        //处理数据
        if (item.qType == '0501') {
          this.danxuanList = item.qList_0501;
          if (this.danxuanList.length) {
            this.danxuanList.forEach(v => {
              //分割图片和题目
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.z) {
                this.percentageNum = this.percentageNum + 1;
              }
              v.optionList.forEach(x => {
                let ass = x.opContent.split('*');
                x.opContent = ass[0];
                ass.splice(0, 1);
                ass.splice(ass.length - 1, 1);
                x.imgs = ass;
              });
            });
          }
          console.log(this.danxuanList);
        } else if (item.qType == '0502') {
          this.duoxuanList = item.qList_0502;

          if (this.duoxuanList.length) {
            this.duoxuanList.forEach(v => {
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.z) {
                this.percentageNum = this.percentageNum + 1;
              }
              v.optionList.forEach(x => {
                let ass = x.opContent.split('*');
                x.opContent = ass[0];
                ass.splice(0, 1);
                ass.splice(ass.length - 1, 1);
                x.imgs = ass;
              });
            });
          }
        } else if (item.qType == '0503') {
          this.panduanList = item.qList_0503;

          if (this.panduanList.length) {
            this.panduanList.forEach(v => {
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.userAnswer == null) {
                v.optionList = [
                  { opContent: '是', selected: false },
                  { opContent: '否', selected: false }
                ];
                return false;
              }

              if (v.userAnswer.answer == '01') {
                v.optionList = [
                  { opContent: '是', selected: true },
                  { opContent: '否', selected: false }
                ];
              } else if (v.userAnswer.answer == '00') {
                v.optionList = [
                  { opContent: '是', selected: false },
                  { opContent: '否', selected: true }
                ];
              }else if (v.userAnswer.answer == null) {
                v.optionList = [
                  { opContent: '是', selected: false },
                  { opContent: '否', selected: false }
                ];
              }else {
                v.optionList = [
                  { opContent: '是', selected: false },
                  { opContent: '否', selected: false }
                ];
              }
            });
          }
        } else if (item.qType == '0504') {
          this.jiandaList = item.qList_0504;

          if (this.jiandaList.length) {
            this.jiandaList.forEach(v => {
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.z) {
                this.percentageNum = this.percentageNum + 1;
              }
              if (v.userAnswer !== null) {
                if (v.userAnswer.answer !== '' && v.userAnswer.answer !== null) {
                  v.z = v.userAnswer.answer;
                }
              }
            });
          }
        } else {
          this.shicaoList = item.qList_0506;
          if (this.shicaoList.length) {
            this.shicaoList.forEach(v => {
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.z) {
                this.percentageNum = this.percentageNum + 1;
              }
              //处理阅读理解题下的单选多选简答判断
              if (v.read_1.length) {
                v.read_1.forEach(cc => {
                  //分割图片和题目
                  let sArr = cc.question.content.split('*');
                  cc.question.content = sArr[0];
                  sArr.splice(0, 1);
                  sArr.splice(sArr.length - 1, 1);
                  cc.imgs = sArr;
                  cc.question.optionList.forEach(x => {
                    let ass = x.opContent.split('*');
                    x.opContent = ass[0];
                    ass.splice(0, 1);
                    ass.splice(ass.length - 1, 1);
                    x.imgs = ass;
                  });
                });
              }
              if (v.read_2.length) {
                v.read_2.forEach(cc => {
                  //分割图片和题目
                  let sArr = cc.question.content.split('*');
                  cc.question.content = sArr[0];
                  sArr.splice(0, 1);
                  sArr.splice(sArr.length - 1, 1);
                  cc.imgs = sArr;
                  cc.question.optionList.forEach(x => {
                    let ass = x.opContent.split('*');
                    x.opContent = ass[0];
                    ass.splice(0, 1);
                    ass.splice(ass.length - 1, 1);
                    x.imgs = ass;
                  });
                });
              }

              if (v.read_3.length) {
                v.read_3.forEach(cc => {
                  let arr = cc.question.content.split('*');
                  cc.question.content = arr[0];
                  arr.splice(0, 1);
                  arr.splice(arr.length - 1, 1);
                  cc.imgs = arr;
                  if (cc.question.userAnswer == null) {
                    cc.optionList = [
                      { opContent: '是', selected: false },
                      { opContent: '否', selected: false }
                    ];
                    return false;
                  }
                  if (cc.question.userAnswer == '01') {
                    cc.optionList = [
                      { opContent: '是', selected: true },
                      { opContent: '否', selected: false }
                    ];
                  } else if (cc.question.userAnswer == '00') {
                    cc.optionList = [
                      { opContent: '是', selected: false },
                      { opContent: '否', selected: true }
                    ];
                  }else {
                    cc.optionList = [
                      { opContent: '是', selected: false },
                      { opContent: '否', selected: false }
                    ];
                  }
                });
              }

              if (v.read_4.length) {
                v.read_4.forEach(cc => {
                  let arr = cc.question.content.split('*');
                  cc.question.content = arr[0];
                  arr.splice(0, 1);
                  arr.splice(arr.length - 1, 1);
                  cc.imgs = arr;
                  if (cc.question.userAnswer !== null) {
                    cc.z = cc.question.userAnswer;
                  }
                });
              }
            });
          }
        }
      });
      this.percentage();
    });
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.getCompetence();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.scollBox {
  overflow-x: hidden;
}
.scollBox::-webkit-scrollbar {
  width: 4px;
}
.scollBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.scollBox::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.box1 {
  height:700px; overflow-y: auto
}

.box2 {
  display: flex; font-size: 18px; font-family: Medium
}

.box3 {
  margin-top: 2px; width: 4px; height: 20px; background: #4275f5
}

.box4 {
  margin-left: 8px
}
.box5 {
  margin-top: 24px; font-family: Medium
}
.box6 {
  color: #333333; font-size: 15px
}
.box7 {
  width: 30px; height: 30px; border-radius: 50%; text-align: center; line-height: 30px; margin: 10px 10px 0 0;cursor: pointer;
}
.box8 {
  margin-left: 13px
}
.box9 {
  margin-left: 5px
}
.box10 {
  margin: 10px auto auto auto
}
.box11 {
  height: 550px; overflow-y: auto
}
.box12 {
  width: 20px; height: 20px; margin-top: 2px
}
.box13 {
  margin: 0px 5px
}
.box14 {
  color: #fff; background: #507df7; border: 0; margin-left: 50px
}
.box15 {
  width: 480px
}
.box16 {
  height: 220px
}
.box17 {
  padding: 5px; font-size: 16px; color: #272748; width: 100%; height: auto;
}
.box18 {
  height: 650px; overflow-y: auto; width: 494px
}
.box19{
  font-size: 16px; font-family: Regular; margin-bottom: 10px
}
.box20 {
  margin-top: 5px
}

.box21 {
  height: 540px; background: #fff; padding: 28px 20px; border-radius: 12px
}
.box22 {
  display: flex; font-size: 18px; font-family: Medium
}
.box23 {
  margin-top: 20px
}
.box24 {
  margin-top: 10px; width: 240px; height: 250px; background: #ffffff; border-radius: 12px; padding: 28px 20px
}
.box25 {
  margin-left: 40px; margin-top: 20px;font-size: 14px;
}
.box26 {
  display: flex; margin-top: 8px
}
.box27 {
  margin-top: 24px; font-family: Medium; font-size: 14px
}
.box28 {
  width: 16px; height: 16px; margin-top: 4px
}

.color11 {
  background: rgb(126, 59, 142);
  color: #fff;
}
.yuan {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  opacity: 1;
}
.successBox {
  width: 100%;
  color: #5ad068;
  padding: 10px;
  background: rgba(90, 208, 104, 0.1);
  border-radius: 12px;
  font-size: 16px;
  font-family: Medium;
}
.digSHowBox {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
  .cameraBox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: 380px;
    background: #ffffff;
    border-radius: 12px;
    padding: 25px 25px;
    font-family: Medium;
    font-size: 16px;
    .bkBox {
      width: 172px;
      height: 172px;
      margin: 0 auto;
      position: relative;
      .bk {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .camerBtn {
      width: 180px;
      height: 50px;
      background: #4275f5;
      opacity: 1;
      border-radius: 25px;
      font-family: Medium;
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      margin: 28px auto auto auto;
    }
  }
}
.camera_outer {
  position: relative;
  overflow: hidden;
  // background: url("../../assets/img/user_0608_04.png") no-repeat center;
  background-size: 100%;

  video,
  canvas,
  .tx_img {
    -moz-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  .btn_camera {
    position: absolute;
    bottom: 4px;
    left: 0;
    right: 0;
    height: 50px;
    background-color: rgba(0, 0, 0, 0.3);
    line-height: 50px;
    text-align: center;
    color: #ffffff;
  }

  .bg_r_img {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  .img_bg_camera {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;

    img {
      width: 300px;
      height: 300px;
    }

    .img_btn_camera {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.3);
      color: #ffffff;

      .loding_img {
        width: 50px;
        height: 50px;
      }
    }
  }
}
.scollBox {
  overflow-x: hidden;
}
.scollBox::-webkit-scrollbar {
  width: 4px;
}
.scollBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.scollBox::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.header {
  width: 100%;
  height: 60px;
  background: url('../../assets/listImgs/head_bc@2x.png') 100% 100%;
  padding: 0 100px;
  line-height: 60px;
  font-family: Medium;
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 18px;

  .time {
    width: 220px;
    height: 40px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 31px;
    margin-top: 10px;
    font-size: 16px;
    color: #fff;
    line-height: 40px;
    text-align: center;
  }
}

.examBanner {
  margin-top: 15px;
  padding: 0 100px;
  display: flex;
  .examLeft {
    width: 240px;
    height: 800px;
    background: #ffffff;
    opacity: 1;
    border-radius: 12px;
    padding: 28px 20px;

    .danBox {
      display: flex;
      flex-wrap: wrap;
      font-family: Medium;
      font-size: 14px;
      .color5 {
        background: #5ad068;
        color: #fff;
        cursor: pointer;
      }
      .color6 {
        background: #f1f3f7;
        color: #8793a4;
        cursor: pointer;
      }
      .color7 {
        background: #fe5f5e;
        color: #fff;
        cursor: pointer;
      }
      div:nth-child(5n) {
        margin-right: 0 !important;
      }
    }
    .optionTips {
      width: 200px;
      height: 50px;
      border: 1px solid #8793a4;
      opacity: 1;
      border-radius: 12px;
      color: #666666;
      font-family: Regular;
      font-size: 14px;
      .yuan {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        opacity: 1;
      }
    }
  }
  .examCenter {
    width: 1220px;
    height: 800px;
    background: #ffffff;
    opacity: 1;
    border-radius: 12px;
    margin-left: 10px;
    padding: 20px;
    .timu {
      position: relative;
      width: 650px;
      max-height: 760px;

      background: #f5f7fb;
      opacity: 1;
      border-radius: 12px;
      overflow-y: auto;
      padding: 54px 25px;
      color: #333333;
      font-family: Medium;
      font-size: 18px;
      .titleTips {
        position: absolute;
        top: 0;
        left: 0;
        width: 72px;
        height: 30px;
        background: #59cc62;
        border-radius: 12px 0px 12px 0px;
        color: #fff;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
      }
    }
    .timu::-webkit-scrollbar {
      width: 4px;
    }
    .timu::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.2);
    }
    .timu::-webkit-scrollbar-track {
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }
    .xuanx {
      margin-left: 35px;
      .xuan {
        width: 480px;
        min-height: 60px;
        background: #f5f7fb;
        opacity: 1;
        border-radius: 12px;
        padding: 20px;
        display: flex;
        font-size: 16px;
        font-family: Regular;
        cursor: pointer;
        margin-bottom: 20px;
      }

      .seletXuan {
        background: rgba(90, 208, 104, 0.1) !important;
        color: #5ad068 !important;
      }

      .noseletXuan {
        background: rgba(254, 95, 94, 0.1) !important;
        color: #fe5f5e !important;
      }

      .switchBox {
        display: flex;
        margin-left: 55px;
        margin-top: 10px;
        .btn {
          width: 160px;
          height: 50px;
          border: 1px solid #4275f5;
          opacity: 1;
          border-radius: 25px;
          cursor: pointer;
          text-align: center;
          line-height: 50px;
          font-family: Medium;
          font-size: 16px;
        }
      }
    }
  }
  .examRight {
    width: 240px;
    height: 800px;
    opacity: 1;
    border-radius: 12px;
    margin-left: 10px;
    .fs {
      font-family: Regular;
      font-size: 14px;
      color: #666666;
      line-height: 23px;
      height: 420px;
      overflow-y: scroll;
    }
    .qd {
      margin-left: 20px;
      margin-top: 30px;
      width: 160px;
      height: 50px;
      background: #d3d3d3;
      opacity: 1;
      border-radius: 12px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 16px;
      font-family: Medium;
    }
    .submit {
      margin-left: 20px;
      margin-top: 42px;
      width: 160px;
      height: 50px;
      background: #fe5f5e;
      box-shadow: 0px 3px 6px rgba(254, 95, 94, 0.31);
      opacity: 1;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #fff;
      font-size: 16px;
      font-family: Medium;
    }
  }
}
</style>
